export enum TranslationKeys {
    // #region Common
    COMMON_BACK = 'common.back',
    COMMON_CONTINUE = 'common.continue',
    COMMON_SUBMIT = 'common.submit',
    COMMON_CANCEL = 'common.cancel',
    COMMON_SAVE = 'common.save',
    COMMON_DELETE = 'common.delete',
    COMMON_EDIT = 'common.edit',
    COMMON_ADD = 'common.add',
    COMMON_SEARCH = 'common.search',
    COMMON_FILTER = 'common.filter',
    COMMON_DOWNLOAD = 'common.download',
    COMMON_UPLOAD = 'common.upload',
    COMMON_LOADING = 'common.loading',
    COMMON_NO_DATA = 'common.noData',
    COMMON_CONTACT_US = 'common.contactUs',
    COMMON_REPORT_INCORRECT = 'common.reportIncorrect',
    COMMON_ENROLL_NOW = 'common.enrollNow',
    COMMON_YES = 'common.yes',
    COMMON_NO = 'common.no',
    COMMON_LOGOUT = 'common.logout',
    // #endregion

    // #region Login
    LOGIN_TITLE = 'login.title',
    LOGIN_EMAIL_ADDRESS = 'login.emailAddress',
    LOGIN_PASSWORD = 'login.password',
    LOGIN_FORGOT_PASSWORD = 'login.forgotPassword',
    LOGIN_LOGIN_BUTTON = 'login.loginButton',
    LOGIN_INVALID_CREDENTIALS = 'login.invalidCredentials',
    LOGIN_ENTER_VALID_EMAIL = 'login.enterValidEmail',
    LOGIN_ENTER_PASSWORD = 'login.enterPassword',
    LOGIN_INCIDENT_REPORTING = 'login.incidentReporting',
    LOGIN_GL_QUOTE = 'login.glQuote',
    // #endregion

    // #region ForgotPassword
    FORGOT_PASSWORD_TITLE = 'forgotPassword.title',
    FORGOT_PASSWORD_INSTRUCTION = 'forgotPassword.instruction',
    FORGOT_PASSWORD_EMAIL_ADDRESS = 'forgotPassword.emailAddress',
    FORGOT_PASSWORD_SEND_BUTTON = 'forgotPassword.sendButton',
    FORGOT_PASSWORD_BACK_TO_LOGIN = 'forgotPassword.backToLogin',
    FORGOT_PASSWORD_ENTER_VALID_EMAIL = 'forgotPassword.enterValidEmail',
    FORGOT_PASSWORD_CHECK_EMAIL = 'forgotPassword.checkEmail',
    FORGOT_PASSWORD_EMAIL_SENT = 'forgotPassword.emailSent',
    FORGOT_PASSWORD_DID_NOT_RECEIVE = 'forgotPassword.didNotReceive',
    // #endregion

    // #region ResetPassword
    RESET_PASSWORD_TITLE = 'resetPassword.title',
    RESET_PASSWORD_NEW_PASSWORD = 'resetPassword.newPassword',
    RESET_PASSWORD_CONFIRM_PASSWORD = 'resetPassword.confirmPassword',
    RESET_PASSWORD_RESET_BUTTON = 'resetPassword.resetButton',
    RESET_PASSWORD_PASSWORD_MISMATCH = 'resetPassword.passwordMismatch',
    RESET_PASSWORD_PASSWORD_MIN_LENGTH = 'resetPassword.passwordMinLength',
    RESET_PASSWORD_SUCCESS = 'resetPassword.success',
    RESET_PASSWORD_ERROR = 'resetPassword.error',
    RESET_PASSWORD_PASSWORD_REQUIRED = 'resetPassword.passwordRequired',
    RESET_PASSWORD_DESCRIPTION = 'resetPassword.description',
    // #endregion

    // #region Welcome
    WELCOME_TITLE = 'welcome.title',
    WELCOME_INTRO = 'welcome.intro',
    WELCOME_PROCEED_BUTTON = 'welcome.proceedButton',
    WELCOME_STEP1 = 'welcome.step1',
    WELCOME_STEP2 = 'welcome.step2',
    WELCOME_STEP3 = 'welcome.step3',
    WELCOME_EMAIL = 'welcome.email',
    WELCOME_CREATE_PASSWORD = 'welcome.createPassword',
    WELCOME_REGISTER = 'welcome.register',
    WELCOME_ALREADY_REGISTERED = 'welcome.alreadyRegistered',
    WELCOME_SIGN_IN = 'welcome.signIn',
    WELCOME_QUESTIONS = 'welcome.questions',
    WELCOME_ENTER_EMAIL = 'welcome.enterEmail',
    WELCOME_ENTER_PASSWORD = 'welcome.enterPassword',
    WELCOME_CONFIRM_EMAIL_SUCCESS = 'welcome.confirmEmailSuccess',
    WELCOME_CONFIRM_EMAIL_ERROR = 'welcome.confirmEmailError',
    // #endregion

    // #region Verification
    VERIFICATION_TITLE = 'verification.title',
    VERIFICATION_SUBTITLE = 'verification.subtitle',
    VERIFICATION_FULL_LEGAL_NAME = 'verification.fullLegalName',
    VERIFICATION_ADDRESS = 'verification.address',
    VERIFICATION_CITY = 'verification.city',
    VERIFICATION_STATE = 'verification.state',
    VERIFICATION_ZIP_CODE = 'verification.zipCode',
    VERIFICATION_PHONE = 'verification.phone',
    VERIFICATION_EMAIL = 'verification.email',
    VERIFICATION_WEBSITE = 'verification.website',
    VERIFICATION_CONFIRM_DATA = 'verification.confirmData',
    VERIFICATION_PLEASE_CONFIRM = 'verification.pleaseConfirm',
    VERIFICATION_NOTE = 'verification.note',
    VERIFICATION_IS_THIS_YOU = 'verification.isThisYou',
    VERIFICATION_AFP_ACCOUNT_INFO = 'verification.afpAccountInfo',
    VERIFICATION_IF_SO_CONTINUE = 'verification.ifSoContinue',
    VERIFICATION_USER_NAME = 'verification.userName',
    VERIFICATION_MOBILE_PHONE = 'verification.mobilePhone',
    VERIFICATION_INSURED_NAME = 'verification.insuredName',
    VERIFICATION_AMAZON_SCAC_CODE = 'verification.amazonScacCode',
    VERIFICATION_DOT_NUMBER = 'verification.dotNumber',
    VERIFICATION_REPORT = 'verification.report',
    VERIFICATION_INCORRECT_INFO = 'verification.incorrectInfo',
    // #endregion

    // #region VerificationTractors
    VERIFICATION_TRACTORS_TITLE = 'verificationTractors.title',
    VERIFICATION_TRACTORS_SUBTITLE = 'verificationTractors.subtitle',
    VERIFICATION_TRACTORS_VIN = 'verificationTractors.vin',
    VERIFICATION_TRACTORS_YEAR = 'verificationTractors.year',
    VERIFICATION_TRACTORS_MAKE = 'verificationTractors.make',
    VERIFICATION_TRACTORS_EQUIPMENT_ID = 'verificationTractors.equipmentId',
    VERIFICATION_TRACTORS_FUEL_TYPE = 'verificationTractors.fuelType',
    VERIFICATION_TRACTORS_PICKUP_DATE = 'verificationTractors.pickupDate',
    VERIFICATION_TRACTORS_RETURN_DATE = 'verificationTractors.returnDate',
    VERIFICATION_TRACTORS_NO_DATA_FILTER = 'verificationTractors.noDataFilter',
    // #endregion

    // #region VerificationDrivers
    VERIFICATION_DRIVERS_TITLE = 'verificationDrivers.title',
    VERIFICATION_DRIVERS_FIRST_NAME = 'verificationDrivers.firstName',
    VERIFICATION_DRIVERS_LAST_NAME = 'verificationDrivers.lastName',
    VERIFICATION_DRIVERS_DATE_OF_BIRTH = 'verificationDrivers.dateOfBirth',
    VERIFICATION_DRIVERS_HIRE_DATE = 'verificationDrivers.hireDate',
    VERIFICATION_DRIVERS_LICENSE_STATE = 'verificationDrivers.licenseState',
    VERIFICATION_DRIVERS_LICENSE_NUMBER = 'verificationDrivers.licenseNumber',
    VERIFICATION_DRIVERS_YEARS_DRIVING_EXPERIENCE = 'verificationDrivers.yearsDrivingExperience',
    VERIFICATION_DRIVERS_TERM_DATE = 'verificationDrivers.termDate',
    VERIFICATION_DRIVERS_ACTION = 'verificationDrivers.action',
    VERIFICATION_DRIVERS_ADD_DRIVER = 'verificationDrivers.addDriver',
    VERIFICATION_DRIVERS_EDIT_DRIVER = 'verificationDrivers.editDriver',
    VERIFICATION_DRIVERS_ACTIVE_DRIVERS = 'verificationDrivers.activeDrivers',
    VERIFICATION_DRIVERS_ALL_DRIVERS = 'verificationDrivers.allDrivers',
    VERIFICATION_DRIVERS_TERMINATED_DRIVERS = 'verificationDrivers.terminatedDrivers',
    VERIFICATION_DRIVERS_CONFIRM_DATA = 'verificationDrivers.confirmData',
    VERIFICATION_DRIVERS_DRIVER_SUCCESSFULLY_ADDED = 'verificationDrivers.driverSuccessfullyAdded',
    VERIFICATION_DRIVERS_DRIVER_SUCCESSFULLY_UPDATED = 'verificationDrivers.driverSuccessfullyUpdated',
    // #endregion

    // #region Coverage
    COVERAGE_TITLE = 'coverage.title',
    COVERAGE_POLICY_SUMMARY = 'coverage.policySummary',
    COVERAGE_QUOTE = 'coverage.quote',
    COVERAGE_POLICY_NUMBER = 'coverage.policyNumber',
    COVERAGE_EFFECTIVE_DATE = 'coverage.effectiveDate',
    COVERAGE_EXPIRATION_DATE = 'coverage.expirationDate',
    COVERAGE_STATUS = 'coverage.status',
    COVERAGE_PREMIUM = 'coverage.premium',
    COVERAGE_ACTIVE = 'coverage.active',
    COVERAGE_INACTIVE = 'coverage.inactive',
    COVERAGE_VIEW_PROPOSAL = 'coverage.viewProposal',
    COVERAGE_VIEW_DOCUMENTS = 'coverage.viewDocuments',
    COVERAGE_VIEW_ANALYTICS = 'coverage.viewAnalytics',
    COVERAGE_UNIT_ID_CARDS = 'coverage.unitIdCards',
    COVERAGE_DRIVER_INFORMATION = 'coverage.driverInformation',
    COVERAGE_INSURANCE_SUMMARY = 'coverage.insuranceSummary',
    COVERAGE_AFP_ACCOUNT_INFO = 'coverage.afpAccountInfo',
    COVERAGE_MISC_DOCUMENTS = 'coverage.miscDocuments',
    COVERAGE_INCIDENTS_REPORTED = 'coverage.incidentsReported',
    // #endregion

    // #region CoverageProposal
    COVERAGE_PROPOSAL_TITLE_ACTIVE = 'coverageProposal.titleActive',
    COVERAGE_PROPOSAL_TITLE_INACTIVE = 'coverageProposal.titleInactive',
    COVERAGE_PROPOSAL_REVIEW_TERMS = 'coverageProposal.reviewTerms',
    // #endregion

    // #region EnrollmentConfirmation
    ENROLLMENT_CONFIRMATION_TITLE = 'enrollmentConfirmation.title',
    ENROLLMENT_CONFIRMATION_MESSAGE = 'enrollmentConfirmation.message',
    ENROLLMENT_CONFIRMATION_RETURN_HOME = 'enrollmentConfirmation.returnHome',
    ENROLLMENT_CONFIRMATION_MESSAGE1 = 'enrollmentConfirmation.message1',
    ENROLLMENT_CONFIRMATION_HERE = 'enrollmentConfirmation.here',
    ENROLLMENT_CONFIRMATION_MESSAGE2 = 'enrollmentConfirmation.message2',
    ENROLLMENT_CONFIRMATION_VIEW_AFP_PAGE = 'enrollmentConfirmation.viewAfpPage',
    // #endregion

    // #region Home
    HOME_WELCOME = 'home.welcome',
    HOME_ACTIVE_POLICIES = 'home.activePolicies',
    HOME_PENDING_ACTIONS = 'home.pendingActions',
    HOME_RECENT_DOCUMENTS = 'home.recentDocuments',
    HOME_QUICK_LINKS = 'home.quickLinks',
    HOME_USER_INACTIVE = 'home.userInactive',
    // #endregion

    // #region Documents
    DOCUMENTS_TITLE = 'documents.title',
    DOCUMENTS_TYPE = 'documents.type',
    DOCUMENTS_DATE_CREATED = 'documents.dateCreated',
    DOCUMENTS_FILE_NAME = 'documents.fileName',
    DOCUMENTS_CATEGORY = 'documents.category',
    DOCUMENTS_ACTION = 'documents.action',
    DOCUMENTS_POLICY_DOCUMENTS = 'documents.policyDocuments',
    DOCUMENTS_INSURED_DOCUMENTS = 'documents.insuredDocuments',
    DOCUMENTS_QUOTE = 'documents.quote',
    DOCUMENTS_INSURED = 'documents.insured',
    DOCUMENTS_DOWNLOAD_ALL = 'documents.downloadAll',
    // #endregion

    // #region Analytics
    ANALYTICS_TITLE = 'analytics.title',
    ANALYTICS_SUMMARY = 'analytics.summary',
    ANALYTICS_CLAIMS = 'analytics.claims',
    ANALYTICS_SCAC = 'analytics.scac',
    ANALYTICS_AFP_NAME = 'analytics.afpName',
    ANALYTICS_INCIDENTS = 'analytics.incidents',
    ANALYTICS_INCURRED = 'analytics.incurred',
    ANALYTICS_CLAIM_NUMBER = 'analytics.claimNumber',
    ANALYTICS_DATE_OF_LOSS = 'analytics.dateOfLoss',
    ANALYTICS_CLAIM_STATUS = 'analytics.claimStatus',
    ANALYTICS_COVERAGE = 'analytics.coverage',
    ANALYTICS_AMAZON_ID = 'analytics.amazonId',
    ANALYTICS_LOSS_DESCRIPTION = 'analytics.lossDescription',
    ANALYTICS_VALUE_DATE = 'analytics.valueDate',
    // #endregion

    // #region Policies
    POLICIES_TITLE = 'policies.title',
    POLICIES_REQUESTS = 'policies.requests',
    POLICIES_GENERAL_LIABILITY_QUOTE = 'policies.generalLiabilityQuote',
    POLICIES_CLAIMS_REPORTING = 'policies.claimsReporting',
    // #endregion

    // #region Rolling
    ROLLING_TITLE = 'rolling.title',
    ROLLING_MESSAGE = 'rolling.message',
    // #endregion

    // #region Error
    ERROR_TITLE = 'error.title',
    ERROR_PAGE_NOT_FOUND = 'error.pageNotFound',
    ERROR_UNAUTHORIZED = 'error.unauthorized',
    ERROR_SERVER_ERROR = 'error.serverError',
    ERROR_RETURN_HOME = 'error.returnHome',
    // #endregion

    // #region DriversModal
    DRIVERS_MODAL_ADD_TITLE = 'driversModal.addTitle',
    DRIVERS_MODAL_EDIT_TITLE = 'driversModal.editTitle',
    DRIVERS_MODAL_FIRST_NAME = 'driversModal.firstName',
    DRIVERS_MODAL_LAST_NAME = 'driversModal.lastName',
    DRIVERS_MODAL_DATE_OF_BIRTH = 'driversModal.dateOfBirth',
    DRIVERS_MODAL_HIRE_DATE = 'driversModal.hireDate',
    DRIVERS_MODAL_LICENSE_STATE = 'driversModal.licenseState',
    DRIVERS_MODAL_LICENSE_NUMBER = 'driversModal.licenseNumber',
    DRIVERS_MODAL_YEARS_DRIVING_EXPERIENCE = 'driversModal.yearsDrivingExperience',
    DRIVERS_MODAL_TERM_DATE = 'driversModal.termDate',
    DRIVERS_MODAL_SAVE = 'driversModal.save',
    DRIVERS_MODAL_CANCEL = 'driversModal.cancel',
    DRIVERS_MODAL_REQUIRED = 'driversModal.required',
    DRIVERS_MODAL_ENTER_VALID_STATE = 'driversModal.enterValidState',
    DRIVERS_MODAL_VALUE_RANGE = 'driversModal.valueRange',
    // #endregion

    // #region Toast
    TOAST_SUCCESS = 'toast.success',
    TOAST_ERROR = 'toast.error',
    TOAST_WARNING = 'toast.warning',
    TOAST_INFO = 'toast.info',
    // #endregion

    // #region Validation
    VALIDATION_REQUIRED = 'validation.required',
    VALIDATION_EMAIL = 'validation.email',
    VALIDATION_MIN_LENGTH = 'validation.minLength',
    VALIDATION_MAX_LENGTH = 'validation.maxLength',
    VALIDATION_PATTERN = 'validation.pattern',
    VALIDATION_PASSWORD_MISMATCH = 'validation.passwordMismatch',
    // #endregion

    // #region GeneralErrors
    GENERAL_ERRORS_NO_INTERNET_CONNECTION = 'general-errors.no-internet-connection',
    GENERAL_ERRORS_SERVER_NOT_RESPOND = 'general-errors.server-not-respond',
    GENERAL_ERRORS_INTERNAL_SERVER_ERROR = 'general-errors.internal-server-error',
    // #endregion

    // #region LanguageSwitcher
    LANGUAGE_SWITCHER_AUTO_SELECTED_TOOLTIP = 'languageSwitcher.autoSelectedTooltip',
    LANGUAGE_SWITCHER_CLICK_TO_CHANGE_TOOLTIP = 'languageSwitcher.clickToChangeTooltip',
    LANGUAGE_SWITCHER_AUTO_INDICATOR_TOOLTIP = 'languageSwitcher.autoIndicatorTooltip',
    // #endregion

    // #region EmailSubjects
    EMAIL_SUBJECTS_GENERAL_LIABILITY_REQUEST = 'emailSubjects.generalLiabilityRequest',
    // #endregion
}